import { createWorkspaceQueries, type WorkspaceQueries } from '../domain/queries.ts';
import type { WorkspaceId } from '../domain/types.ts';
import { demoRepository } from './generate.ts';
export { createDemoRepository, generateWorkspace, demoRepository, HISTORY_DAYS, DEMO_USER_ID } from './generate.ts';
export type { SeedOptions } from './generate.ts';
export { WORKSPACES, STORY_IDS } from './catalog.ts';
const queries = new Map<WorkspaceId, WorkspaceQueries>();
export function getWorkspaceQueries(id: WorkspaceId): WorkspaceQueries {
  let q = queries.get(id);
  if (!q) { q = createWorkspaceQueries(demoRepository.getWorkspace(id)); queries.set(id, q); }
  return q;
}
